import axios from "axios";
import { AxiosRequestConfig } from "axios";
import { store } from "@/store";

import { getValue } from "@/env";


const config = {
	// baseURL: process.env.API_URL
}

const http = axios.create(config);

// adds authorization token to request
export const addAuthToRequest = (config:AxiosRequestConfig) => {
	if(!config.headers["Authorization"]){
		let token = store.getters.token;
		if(token){
			config.headers["Authorization"] = `bearer ${token}`;
		}
	}
	return config;
};

const addBaseURL = (config:AxiosRequestConfig) => {
	config.baseURL = getValue("API_URL");
	return config;
};

http.interceptors.request.use(addBaseURL); // prepend base url
http.interceptors.request.use(addAuthToRequest, error => Promise.reject(error)); // apply auth



export { http }